export default {
  eventBannerImageUrl: "https://static.agrostar.in/static/Sale",
  eventBannerLogoUrl: "https://static.agrostar.in/static/SaleTag",
  eventScrollBackgroundImage: "/icons/independentSale.png",
  eventStartDate: new Date("2023-13-22 04:35 PM"), // YYYY-MM-DD 00:00 AM/PM
  eventEndDate: new Date("2023-10-25 03:43 PM"), // YYYY-MM-DD 00:00 AM/PM
};
